import { createFileRoute } from '@tanstack/react-router';

import Logout from 'component/view/Auth/Logout';

export const Route = createFileRoute('/logout')({
  component: Logout,
});
